import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '@mui/material';
import { trackBeginCheckout } from '../analytics';

export default function Pricing() {
  return (
    <div>
      <Header />
      <main style={{ padding: 24 }}>
        <h1>Simple, transparent pricing</h1>
        <section>
          <h2>Free — $0</h2>
          <p>3 assets, basic tracking</p>
          <p>
            <Button variant="contained" onClick={() => trackBeginCheckout('free', 0)}>Start Free</Button>
          </p>
        </section>
        <section>
          <h2>Pro — $9.99/mo</h2>
          <p>Up to 15 assets • AI • Email/SMS • CSV • Compliance</p>
          <p>
            <Button variant="outlined" onClick={() => trackBeginCheckout('pro', 9.99)}>Get Pro</Button>
          </p>
        </section>
        <section>
          <h2>Fleet — $29/mo</h2>
          <p>Unlimited assets • Everything in Pro • Phone support • API (soon)</p>
          <p>
            <Button variant="outlined" onClick={() => trackBeginCheckout('fleet', 29)}>Get Fleet</Button>
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
}
